var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import * as Util from '../util';

var ZonaSvg = function (_Component) {
  _inherits(ZonaSvg, _Component);

  function ZonaSvg() {
    var _temp, _this, _ret;

    _classCallCheck(this, ZonaSvg);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleMouseEnter = function () {
      _this.props.zona.zonasAsociadas.forEach(function (zonaAsocidadaId) {
        var zonaAsociada = document.getElementById(zonaAsocidadaId);

        if (zonaAsociada && !zonaAsociada.classList.contains('overZona')) {
          zonaAsociada.classList.add('overZona');
        }
      });
    }, _this.handleMouseleave = function () {
      _this.props.zona.zonasAsociadas.forEach(function (zonaAsocidadaId) {
        var zonaAsociada = document.getElementById(zonaAsocidadaId);

        if (zonaAsociada && zonaAsociada.classList.contains('overZona')) {
          zonaAsociada.classList.remove('overZona');
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ZonaSvg.prototype.esPoligonal = function esPoligonal() {
    return this.props.zona.boton.includes(':');
  };

  ZonaSvg.prototype.calcularPoints = function calcularPoints() {
    var multiplicadorBaja = this.props.multiplicadorBaja;
    var boton = this.props.zona.boton;

    if (this.esPoligonal()) {
      return boton.split(":").map(function (par) {
        return par.split(",").map(function (valor) {
          return Number(valor) / multiplicadorBaja;
        }).join(",");
      }).join(" ");
    }

    var _boton$split$map$map = boton.split(',').map(Number).map(function (valor) {
      return valor / multiplicadorBaja;
    }),
        x = _boton$split$map$map[0],
        y = _boton$split$map$map[1],
        w = _boton$split$map$map[2],
        h = _boton$split$map$map[3];

    return x + ',' + y + ' ' + (x + w) + ',' + y + ' ' + (x + w) + ',' + (y + h) + ' ' + x + ',' + (y + h);
  };

  ZonaSvg.prototype.render = function render() {
    var points = this.calcularPoints();
    var _props = this.props,
        zona = _props.zona,
        onClick = _props.onClick;
    var eventHandlers = Util.is_touch_device() ? {
      onTouchEnd: onClick
    } : {
      onClick: onClick
    };

    if (zona.zonasAsociadas) {
      eventHandlers.onMouseEnter = this.handleMouseEnter;
      eventHandlers.onMouseLeave = this.handleMouseleave;
    }

    if (window.modoTrabajo) {
      var _points$split$0$split = points.split(' ')[0].split(',').map(Number),
          x = _points$split$0$split[0],
          y = _points$split$0$split[1];

      return React.createElement(React.Fragment, null, React.createElement('rect', {
        x: x - 12 > 0 ? x - 12 : 0,
        y: y,
        width: 12,
        height: 12,
        style: {
          fill: 'yellow',
          fillOpacity: 0.6
        }
      }), React.createElement('text', {
        x: x - 12 > 0 ? x - 10 : 2,
        y: y + 12,
        style: {
          fontSize: 12
        }
      }, zona.id.split('.')[1]), React.createElement('polygon', _extends({
        style: {
          stroke: "red",
          storkeWidth: 2,
          strokeOpacity: 0.8
        },
        id: zona.id.split('.').join('_'),
        points: points,
        strokeLinejoin: 'round'
      }, eventHandlers)));
    }

    return React.createElement('polygon', _extends({
      id: zona.id.split('.').join('_'),
      points: points,
      strokeLinejoin: 'round'
    }, eventHandlers));
  };

  return ZonaSvg;
}(Component);

ZonaSvg.propTypes = process.env.NODE_ENV !== "production" ? {
  zona: t.object.isRequired,
  multiplicadorBaja: t.number.isRequired,
  onClick: t.func.isRequired
} : {};
export default ZonaSvg;